import { useTranslation } from "react-i18next";
import { useGlobalStore } from "@/store/GlobalStore";
import {
  BalanceText,
  BalanceTextContent,
  CurrentProgress,
  LevelCard,
  MemberProgressBar,
  MemberSystemWrapper,
  NextLevelContent,
  NextLevelText,
  UserName,
  UserNameIcon,
} from "./atom";
import { Space, ToolTip } from "task-eva-ui";
import { getMemberLevelTranslate } from "@/pages/profile/helper/getMemberLevelTranslate";
import { useMemberSystem } from "./hooks/useMemberSystem";
import { accSub } from "project-config/utils/acc";
import { FoxLevelContentMap } from "../../constants/fox-balance-info";

export function FoxUserInfoBar() {
  const { t } = useTranslation("topup");
  const { t: profileT } = useTranslation("profile");
  const { userInfo, userLevel, currencySymbol, userBalance } = useGlobalStore();
  const { currenProgress, progressbar, percent, nextLevel } = useMemberSystem();

  const LevelContent = (level: number) => {
    return FoxLevelContentMap.get(level);
  };

  return (
    <MemberSystemWrapper>
      <Space gap={6} align={"center"}>
        <UserNameIcon>{userInfo?.userName?.[0].toUpperCase()}</UserNameIcon>
        <UserName>{userInfo?.userName}</UserName>
      </Space>
      <LevelCard>
        <img src={LevelContent(userLevel)?.img} alt="" />
      </LevelCard>
      <NextLevelContent>
        <MemberProgressBar>
          <CurrentProgress
            percent={percent}
            color={LevelContent(userLevel)?.color}
          />
        </MemberProgressBar>
        {nextLevel >= 0 ? (
          <NextLevelText>
            <span>{profileT("next_level_need_recharge_pre")}</span>&nbsp;
            <span className="vip">{getMemberLevelTranslate(nextLevel)}</span>
            &nbsp;
            <span>{profileT("next_level_need_recharge_sub")}</span>&nbsp;
            <span>{` ${currencySymbol}${Number(
              accSub(progressbar, currenProgress).toFixed(2)
            )}`}</span>
          </NextLevelText>
        ) : (
          <NextLevelText>{t("animation_level_diamond_tips")}</NextLevelText>
        )}
      </NextLevelContent>
      <BalanceTextContent>
        <BalanceText>
          <p>{t("topUp_current_balance")}</p>
          <ToolTip content={`${currencySymbol}${userBalance}`} trigger="hover">
            <span className="symbol">{currencySymbol}</span>
            <span className="credit">{userBalance}</span>
          </ToolTip>
        </BalanceText>
        <BalanceText className="border-left">
          <p>{profileT("accumulative_recharge")}</p>
          <ToolTip
            content={`${currencySymbol}${currenProgress}`}
            trigger="hover"
          >
            <span className="symbol">{currencySymbol}</span>
            <span className="credit">{currenProgress}</span>
          </ToolTip>
        </BalanceText>
      </BalanceTextContent>
    </MemberSystemWrapper>
  );
}
